import { cx } from "../lib/format";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Accessible name; render a visible label via Field or alongside. */
  label?: string;
  id?: string;
  className?: string;
}

export function Toggle({ checked, onChange, disabled, label, id, className }: ToggleProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cx(
        "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors",
        checked ? "border-bright bg-bright" : "border-line bg-surface",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cx(
          "absolute left-0.5 h-3.5 w-3.5 rounded-full transition-transform",
          checked ? "translate-x-4 bg-ink" : "translate-x-0 bg-muted",
        )}
      />
    </button>
  );
}
